import { ConfigService } from '@services/webFeeder/config.service';
import { Injectable } from '@angular/core';
import { SocketService } from '@services/webFeeder/socket.service';
import { MessageBook } from '@model/webFeeder/message-book.model';
import { MessageWebFeeder } from '@model/webFeeder/message-web-feeder.model';
import { MessageParameterQuote } from '@model/webFeeder/message-parameter-quote.model';
import { environment } from 'src/environments/environment';
import { Subject, Observable , of, map } from 'rxjs';

export class MessageAggregatedBookValues {
  public symbol: string;
  public count: number;
  public book: any;
  public componentName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AggregatedBookService {
  public messagesAggregatedBook: Observable<MessageBook>;
  private _message: MessageAggregatedBookValues[] = [];
  private serviceSubject = new Subject<MessageEvent>();

  constructor(
    private socketService: SocketService,
    private configService: ConfigService
  ) { }

  public createSubject() {
    const newService = {
      name: 'AggregatedBookType',
      serviceSubject: this.serviceSubject
    };

    this.socketService.register(newService);
    this.messagesAggregatedBook = newService.serviceSubject.pipe(map(data => {
      let item = this._message.find(x => x.symbol === data['parameter']);
      const messageBookTemp: MessageBook = new MessageBook();
      messageBookTemp.symbol = data['parameter'];
      messageBookTemp.type = data['type'];
      messageBookTemp.buy = data['book'].A;
      messageBookTemp.sell = data['book'].B;
      messageBookTemp.errorMessage = data['book'].E;
      if (item) {
        if (data['book'] !== undefined) {
          item.book = messageBookTemp;
        }
        return messageBookTemp;
      } else {
        item = { symbol: data['parameter'], count: 1, book: messageBookTemp };
        this._message.push(item);
      }
      return messageBookTemp;
    }));
  }

  public reconnectSubscribe() {
    this._message.forEach(element => {
      if (element.count > 0) {
        this.sendMessageAggregatedBook('1', element.symbol);
      }
    });
  }

  public subscribeAggregatedBook(symbol: string, componentName: string, numberRows?: string) {
    if (symbol && symbol !== '' && symbol !== undefined) {
      symbol = symbol.trim().replace(' ', '').toLowerCase();
      const item = this._message.filter(x => x.symbol === symbol);
      let total = 0;
      if (item.length === 0) {
        total = 1;
        this._message.push({ symbol: symbol, count: total, book: null });
      } else if (item.length > 0) {
        item[0].count += 1;
        total = item[0].count;
      }
      this.sendMessageAggregatedBook('1', symbol);
      this.configService.writeLog('<<<< SUBSCRIBE AGGREGATED BOOK [' + total + '][' + symbol.toUpperCase()
        + '][' + (componentName ? componentName.toUpperCase() : null) + '] >>>>');
    }
  }

  public unsubscribeAggregatedBook(symbol: string, componentName: string) {
    if (symbol && symbol !== '' && symbol !== undefined) {
      symbol = symbol.trim().replace(' ', '').toLowerCase();
      const item = this._message.filter(x => x.symbol === symbol);
      if (item.length > 0) {
        item[0].count -= 1;
        if (item[0].count <= 0) {
          item[0].book = null;
          this.sendMessageAggregatedBook('0', symbol);
        }
        this.configService.writeLog('<<<< UNSUBSCRIBE AGGREGATED BOOK [' + item[0].count + '][' + symbol.toUpperCase()
          + '][' + (componentName ? componentName.toUpperCase() : null) + '] >>>>');
      }
    }
  }

  private sendMessageAggregatedBook(type: string, symbol: string) {
    const dataMsg: MessageWebFeeder = new MessageWebFeeder();
    dataMsg.token = this.configService.getToken();
    dataMsg.module = 'quotes';
    dataMsg.service = 'aggregatedBook';
    dataMsg.parameterGet = symbol.toLowerCase();
    const messageParameter = new MessageParameterQuote();
    messageParameter.subsbribetype = type;
    messageParameter.delay = environment.delay_book_aggregated;
    dataMsg.parameters = messageParameter;
    setTimeout(() => {
      this.socketService.signService(dataMsg);
    }, 1000);
  }

}
